// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__18ZcJ","header":"MessagesList_header__bTTdZ","chat":"MessagesList_chat__2sClG"};